module.exports = __webpack_public_path__ + "static/media/BS.321eee53.jpg";